import React from 'react';
import { Phone, Mail, MapPin, Instagram, Heart } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer className="bg-gradient-to-br from-pink-50 via-purple-50 to-green-50 pt-12 pb-6">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          {/* Logo & Description */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_nido-pantano/artifacts/dee4ntwm_inbound608062308470737027.jpg" 
                alt="4 KIDS Logo" 
                className="h-12 w-12 object-contain"
              />
              <div>
                <h3 className="text-xl font-bold text-[#E91E8C]">4 KIDS</h3>
                <p className="text-xs text-gray-600">Asilo Nido Pesaro</p>
              </div>
            </div>
            <p className="text-sm text-gray-600 mb-4">
              {t('footer.description')}
            </p>
            <div className="flex gap-3">
              <a 
                href="https://instagram.com/4kids.asilonido" 
                target="_blank" 
                rel="noopener noreferrer"
                className="p-2 rounded-full bg-white hover:bg-pink-100 transition-colors shadow-sm"
              >
                <Instagram className="w-5 h-5 text-[#E91E8C]" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-gray-900 mb-4">{t('footer.quickLinks')}</h4>
            <ul className="space-y-2 text-sm text-gray-600">
              <li><a href="#about" className="hover:text-[#E91E8C] transition-colors">{t('footer.aboutLink')}</a></li>
              <li><a href="#method" className="hover:text-[#E91E8C] transition-colors">{t('footer.methodLink')}</a></li>
              <li><a href="#team" className="hover:text-[#E91E8C] transition-colors">{t('footer.teamLink')}</a></li>
              <li><a href="#schedule" className="hover:text-[#E91E8C] transition-colors">{t('footer.scheduleLink')}</a></li>
              <li><a href="#contact" className="hover:text-[#E91E8C] transition-colors">{t('footer.contactLink')}</a></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold text-gray-900 mb-4">{t('footer.services')}</h4>
            <ul className="space-y-2 text-sm text-gray-600">
              <li>• {t('footer.service1')}</li>
              <li>• {t('footer.service2')}</li>
              <li>• {t('footer.service3')}</li>
              <li>• {t('footer.service4')}</li>
              <li>• {t('footer.service5')}</li>
              <li>• {t('footer.service6')}</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold text-gray-900 mb-4">{t('footer.contacts')}</h4>
            <div className="space-y-3 text-sm text-gray-600">
              <div className="flex items-start gap-2">
                <MapPin className="w-5 h-5 text-[#E91E8C] flex-shrink-0 mt-0.5" />
                <div>
                  <p>Via Faggi 1 (angolo Via Rossi)</p>
                  <p>Pesaro - Quartiere Pantano</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <Phone className="w-5 h-5 text-[#E91E8C]" />
                <a href="tel:3333858164" className="hover:text-[#E91E8C] transition-colors">
                  333 3858164
                </a>
              </div>
              <div className="flex items-center gap-2">
                <Mail className="w-5 h-5 text-[#E91E8C]" />
                <a href="mailto:4kidspesaro@gmail.com" className="hover:text-[#E91E8C] transition-colors">
                  4kidspesaro@gmail.com
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-pink-200 pt-6 mt-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-gray-600">
            <p>{t('footer.copyright')}</p>
            <p className="flex items-center gap-1">
              {t('footer.madeWith')} <Heart className="w-4 h-4 text-pink-500 fill-pink-500" /> {t('footer.madeWithText')}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
